<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title"
            v-if="$parent.mode === 'existing'">Bestand bewerken</h5>
        <h5 class="card-title"
            v-if="$parent.mode === 'new'">Bestand creëren</h5>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-floating mb-2">
              <input type="text"
                     class="form-control"
                     id="schooljaar"
                     placeholder="Schooljaar"
                     readonly
                     v-model="schoolyear" />
              <label for="schooljaar">Schooljaar</label>
            </div>
            <div class="form-floating mb-2">
              <input type="text"
                     class="form-control"
                     :class="{ 'is-invalid': $v.content.school.brincode.$error }"
                     id="brincode"
                     placeholder="Brincode"
                     maxlength="4"
                     @input="content.school.brincode = $event.target.value.toUpperCase()"
                     v-model="content.school.brincode" />
              <label for="brincode">Brincode</label>
            </div>
            <div class="form-floating mb-2">
              <input type="text"
                     class="form-control"
                     id="dependancecode"
                     placeholder="Dependancecode"
                     :class="{ 'is-invalid': $v.content.school.dependancecode.$error }"
                     v-model="content.school.dependancecode" />
              <label for="dependancecode">Dependancecode</label>
            </div>
            <div class="card overview mb-2">
              <div class="card-body">
                <h6>Groepen</h6>
                <div class="d-flex align-items-center justify-content-between">
                  <span v-if="content.groepen.groep">Totaal groepen: {{ content.groepen.groep.length || 0 }}</span>
                  <span v-if="content.groepen.samengestelde_groep">Totaal samengestelde groepen: {{ content.groepen.samengestelde_groep.length || 0 }}</span>
                  <a class="btn btn-outline-primary btn-sm"
                     @click="detailEdit = 'group'">Groepen
                    <font-awesome-icon icon="edit" />
                  </a>
                </div>
              </div>
            </div>
            <div class="card overview mb-2">
              <div class="card-body">
                <h6>Leerkrachten</h6>
                <div class="d-flex align-items-center justify-content-between">
                  <span>Totaal: {{ content.leerkrachten.leerkracht.length || 0 }}</span>
                  <a class="btn btn-outline-primary btn-sm"
                     @click="detailEdit = 'teacher'">Leerkrachten
                    <font-awesome-icon icon="edit" />
                  </a>
                </div>
              </div>
            </div>
            <div class="card overview mb-5">
              <div class="card-body">
                <h6>Leerlingen</h6>
                <div class="d-flex align-items-center justify-content-between">
                  <span>Totaal: {{ content.leerlingen.leerling.length || 0 }}</span>
                  <a class="btn btn-outline-primary btn-sm"
                     @click="detailEdit = 'pupil'">Leerlingen
                    <font-awesome-icon icon="edit" />
                  </a>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <a class="btn btn-outline-primary"
                 @click="setMode()">Annuleren</a>
              <a class="btn btn-secondary"
                 @click="validateContent()">Exporteer bestand
                <font-awesome-icon icon="save" />
              </a>
            </div>
          </div>
          <div class="col-sm-6">
            <group-edit v-if="detailEdit === 'group'"
                        :content="content"></group-edit>
            <teacher-edit v-if="detailEdit === 'teacher'"
                          :content="content"></teacher-edit>
            <pupil-edit v-if="detailEdit === 'pupil'"
                        :content="content"></pupil-edit>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, alphaNum, helpers, numeric } from "vuelidate/lib/validators";

import getCurrentSchoolYear from "@/helpers/getCurrentSchoolYear";
import prepareJSONExport from "@/helpers/export/prepareJSONForExport";
import parseToXMLExport from "@/helpers/export/parseToXMLExport";
import validateContentToExport from "@/helpers/export/validateContentToExport";

import groupEdit from "@/components/detail-components/group-edit.vue";
import teacherEdit from "@/components/detail-components/teacher-edit.vue";
import pupilEdit from "@/components/detail-components/pupil-edit.vue";

const brincodeFormat = helpers.regex("brincodeFormat", /^\d{2}[A-Z]{2}/);
const dependancecodeFormat = helpers.regex("dependancecodeFormat", /^\d{2}$/);

let contentToExport = null;

export default {
  name: "edit",
  components: {
    groupEdit,
    teacherEdit,
    pupilEdit,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      detailEdit: "",
      schoolyear: getCurrentSchoolYear(),
    };
  },
  validations: {
    content: {
      school: {
        brincode: { required, alphaNum, brincodeFormat },
        dependancecode: { required, numeric, dependancecodeFormat },
      },
    },
  },
  methods: {
    mounted() {
      this.$nextTick(() => {
        this.$v.$touch();
      });
    },
    setMode() {
      this.$parent.mode = "";
      this.$parent.filelist = null;
      this.$parent.content = null;
      this.$emit("resetNewContent");
    },
    validateContent() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      validateContentToExport(this.content).then((valid) => {
        if (valid.leerkrachten.email.includes(false)) {
          this.$toast.error(
            "Er zijn in de import leerkrachten gedetecteerd met en zonder e-mail adres. Alle leerkrachten moeten of een uniek e-mail adres bevatten of geen van de leerkrachten moet een e-mail bevatten"
          );
        } else if (valid.leerlingen.jaargroep.length) {
          valid.leerlingen.jaargroep.forEach((pupil) => {
            this.$toast.error(
              `Leerling: ${pupil.roepnaam} ${pupil.achternaam} heeft een ongeldige jaargroep`
            );
          });
        } else if (valid.groepen.jaargroep.length) {
          valid.groepen.jaargroep.forEach((group) => {
            this.$toast.error(`Groep: ${group.naam} heeft geen jaargroep`);
          });
        } else {
          this.exportFile();
        }
      });
    },
    async exportFile() {
      this.content.school.schooljaar = this.schoolyear;
      const parsedXML = await parseToXMLExport(
        await prepareJSONExport(contentToExport, this.content)
      );

      this.saveFile(parsedXML);
    },
    saveFile(parsedXML) {
      const date = new Date();
      let xmlBlob = new Blob([parsedXML], { type: "text/xml" });
      let fileNameToSaveAs = `export-${date.getDate()}${date.getMonth() + 1
        }${date.getFullYear()}-${date.getHours()}.${date.getMinutes()}.${date.getSeconds()}.xml`;
      let downloadLink = document.createElement("a");
      downloadLink.download = fileNameToSaveAs;
      if (window.webkitURL != null) {
        downloadLink.href = window.webkitURL.createObjectURL(xmlBlob);
      }
      downloadLink.click();
      this.$toast.success(`XML geëxporteerd naar download folder.`);
    },
  },
};
</script>
